import { useState } from "react";

import { uploadFileToS3 } from "../../api/services/users";

export const useImageUploader = () => {
  const [uploadedIMG, setUploadedIMG] = useState<File | null>(null);
  const [targetURL, setTargetURL] = useState<string>("");
  const [previewIMG, setPreviewIMG] = useState<string>("");
  const [IMGName, setIMGName] = useState<string>("");
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false);

  const handleUploadStart = () => setIsImageUploading(true);

  const handleUploadComplete = (file: File, url: string, fileName: string) => {
    setUploadedIMG(file);
    const reader = new FileReader();
    reader.onloadend = () => setPreviewIMG(reader.result as string);
    reader.readAsDataURL(file);
    setTargetURL(url);
    setIMGName(fileName);
    setIsImageUploading(false);
  };

  const resetImageUpload = () => {
    setUploadedIMG(null);
    setTargetURL("");
    setIMGName("");
  };

  const handleUploadToS3 = async () => await uploadFileToS3(uploadedIMG, targetURL);

  return {
    targetURL,
    uploadedIMG,
    IMGName,
    previewIMG,
    isImageUploading,
    handleUploadStart,
    handleUploadToS3,
    handleUploadComplete,
    resetImageUpload,
  };
};
